/*
 * For use in array filters where you want to preserve the type information
 * of the non-null array items.
 */
export default function notNull<T>(item: T | null): item is T {
    return item !== null;
}
